export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDHfC0q0Ahujq9Pduvjs-y_epGkqEoDZxk',
  authDomain: 'wheelseye-178710.firebaseapp.com',
  databaseURL: 'https://wheelseye-178710.firebaseio.com',
  projectId: 'wheelseye-178710',
  storageBucket: 'wheelseye-178710.appspot.com',
  messagingSenderId: '20420679268',
  appId: '1:20420679268:web:ecb7b387d97f7d35f33171',
  measurementId: 'G-L4BR9TC0V9',
};
